<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-can="['ntax.update']"
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateNtaxPartner"
      />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  props: ['ntaxPartner'],
  methods: {
    async updateNtaxPartner() {
      this.$router.push('/ntax-partners/update/' + this.ntaxPartner.id);
    }
  }
};
</script>
